var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHexagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 53,
    viewBox: "0 0 49 53",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16699 34.7124V18.3818C2.16699 15.5379 3.68245 12.9094 6.1437 11.4845L20.286 3.29683C22.7421 1.87483 25.7692 1.86628 28.2334 3.27438L42.6143 11.4921C45.0975 12.911 46.6301 15.5518 46.6301 18.4119V34.6826C46.6301 37.5707 45.0676 40.2328 42.546 41.641L28.1646 49.6722C25.7357 51.0286 22.7754 51.0203 20.3541 49.6504L6.21225 41.6491C3.71243 40.2347 2.16699 37.5846 2.16699 34.7124Z",
    strokeWidth: 3.18797,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77881 16.9722L7.77881 35.9661",
    strokeWidth: 3.18797,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.147 45.2126L40.5962 35.7157",
    strokeWidth: 3.18797,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6143 7.4752L41.0635 16.9722",
    strokeWidth: 3.18797,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagon);
export default __webpack_public_path__ + "static/media/hexagon.a6a495a6ce62731b3f585abdf65dbf6a.svg";
export { ForwardRef as ReactComponent };